import React from "react";
import { Handle, Position } from "reactflow";

export const Trigger = {
    Message: {
        Inbound: "Trigger.Message.Inbound",
        Outbound: "Trigger.Message.Outbound",
    },
} as const;

export type TriggerType = (typeof Trigger.Message)[keyof typeof Trigger.Message];

export interface TriggerNodeData {
    label?: string;
    title?: string;
    description?: string;
    triggerType?: TriggerType;
}

const TRIGGER_META: Record<TriggerType, { icon: React.ReactNode; defaultTitle: string; defaultDesc: string }> = {
    [Trigger.Message.Inbound]: {
        icon: <div className="automationIconsSprite incoming-trigger-icon"></div>,
        defaultTitle: "Incoming",
        defaultDesc: "When a message comes in"
    },
    [Trigger.Message.Outbound]: {
        icon: <div className="automationIconsSprite outgoing-trigger-icon"></div>,
        defaultTitle: "Outgoing",
        defaultDesc: "When an Outgoing Message Is Sent"
    }
};

const TriggerNodeComponent: React.FC<{ data: TriggerNodeData }> = ({ data }) => {
    const type: TriggerType = data.triggerType ?? Trigger.Message.Inbound;
    const meta = TRIGGER_META[type];
    return (
        <div className="hs-w-350-px position-relative hs-bg-plain-white hs-border-grey trigger-rule-node-trigger rounded-4 p-3" role="article" aria-label={`Trigger: ${data.title ?? meta.defaultTitle}`}>
            <Handle type="source" position={Position.Bottom} id="source" className="opacity-0"/>
            <span className="trigger-rule-node-tag trigger-rule-node-trigger hs-fs-11 hs-fw-600 rounded-3 border-1 hs-border-violet py-1 px-3 hs-color-violet">Trigger</span>
            <div className=" d-flex align-items-center gap-2">
                <div className=" d-flex align-items-center justify-content-center">  
                    {meta.icon}
                </div>
                <div className="trigger-rule-node-content d-flex flex-column gap-1">
                    <span className="hs-fw-600 hs-color-BlackRussian hs-fs-12">{data.title ?? meta.defaultTitle}</span>
                    <span className="hs-fs-12 hs-color-medium-dark">{data.description ?? meta.defaultDesc}</span>
                </div>
            </div>
        </div>
    );
};

export const TriggerNode = React.memo(TriggerNodeComponent);
